<app-features-container
  *ngIf="deviceVariant$ | async | ready as deviceVariant"
  actionButtonName="{{
    '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
  }}"
  [header]="deviceVariant.properties?.value?.value | translateEcowaterDeviceVariant"
  [overlayType]="availableOverlays.Ecowater"
>
  <!-- water.softener.salt.level.days -->
  <app-feature-tile
    *ngIf="saltLevelDays$ | async | ready as feature"
    feature
    label="{{ '+INSTALLATIONS.INSTALLATION.ECOWATER.SALT_LEVEL.TITLE' | translate }}"
    [value]="feature.properties?.remaining | translateEcowaterRemainingProperty"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>
  <ng-container feature *ngIf="leakDetection$ | async | ready as feature">
    <app-feature-tile
      feature
      label="{{ '+INSTALLATIONS.INSTALLATION.ECOWATER.FLOW_VALUE' | translate }}"
      value="{{ feature | value2: featurePropertyKey.maxFlow }} {{
        feature | unit: featurePropertyKey.maxFlow
      }}"
      [attr.data-feature]="feature.feature + '/maxFlow'"
    ></app-feature-tile>
    <app-feature-tile
      feature
      label="{{ '+INSTALLATIONS.INSTALLATION.ECOWATER.FLOW_DURATION' | translate }}"
      value="{{ feature | value2: featurePropertyKey.maxDuration }} {{
        feature | unit: featurePropertyKey.maxDuration
      }}"
      [attr.data-feature]="feature.feature + '/maxDuration'"
    ></app-feature-tile>
  </ng-container>
</app-features-container>
